import React, { useState, useEffect } from 'react';
import {
  getPhosphorusAdjustedGroups,
  getPhosphorusStats,
} from '../../../lib/api';
import { AdjustmentTab } from '../../../components/AdjustmentTab';
import { getChartColors } from '../../../services/chart-colors';

export function PhosphorusAdjustments(props) {
  const {
    onLoad,
    onGroupsAdjustment,
    onFieldAdjustment,
    field,
    ...passThrough
  } = props;

  const [stats, setStats] = useState(null);
  const [groups, setGroups] = useState([]);

  const fieldAdjustment = field.fullFieldAdjustment || 0;

  useEffect(() => {
    Promise.all([getPhosphorusStats(field), getPhosphorusAdjustedGroups(field)])
      .then(([pStats, pGroups]) => {
        if (!pStats) throw new Error('No stats');
        setStats(pStats);
        setGroups(pGroups);
        onLoad('p', pGroups, fieldAdjustment);
      })
      .catch(() => onLoad('p'));
  }, [field, fieldAdjustment, onLoad]);

  return (
    stats && (
      <AdjustmentTab
        {...passThrough}
        ceiling={400}
        multipleOf={5}
        stats={stats}
        groups={groups}
        fieldAdjustment={fieldAdjustment}
        colors={getChartColors('phosphorus-rx')}
        xLabel={`Rate ${field.prescription.product} lbs/ac`}
        onGroupsAdjustment={(newGroups) => onGroupsAdjustment('p', newGroups)}
        onFieldAdjustment={(adjustment) => onFieldAdjustment('p', adjustment)}
      />
    )
  );
}
